import { useApi } from "../../../utils";
import { ProjectClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import type { ProjectIndividual } from "shared-ui/src/features/projects-feature/canonical";
import { mapToProjectIndividual } from "../toCanonical";

const useGetProjectById = (projectId: number) => {
  const isValidProjectId = !isNaN(projectId) && projectId > 0;
  const api = useApi(ProjectClient);

  const loadProject = async (): Promise<ProjectIndividual> => {
    const response = await api.getProjectById(projectId);
    return mapToProjectIndividual(response);
  };

  return useQuery<ProjectIndividual, Error>({
    queryKey: [`project-details-${projectId}`],
    queryFn: loadProject,
    enabled: isValidProjectId,
  });
};

export default useGetProjectById;
